import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import APP from 'app'
import { trackEvent } from 'global-utils/Analytics'
import { Emoji } from 'images'

const versionToNumber = (version) => {
  const parts = `0${version}`.split('.').reverse()
  let number = 0
  parts.forEach((part, index) => {
    number += +part * 10 ** (3 * index)
  })
  return number
}

class AppVersion extends PureComponent {
  isUpToDate() {
    const { os, version } = this.props
    const actualVersion = versionToNumber(version)
    const lastVersion = versionToNumber(APP.env.apps?.[os]?.version || '')
    return !lastVersion || !actualVersion || actualVersion >= lastVersion
  }

  renderAppLink() {
    const { os } = this.props
    return (
      <a
        className="flex gap-2 items-center justify-center font-bold bg-white"
        href={APP.env.apps?.[os]?.store}
        onClick={() => trackEvent('Component', 'Click', `App Version - ${os} Store Link`)}
        rel="noopener noreferrer"
        target="_blank"
      >
        <img alt={`${os} store`} className="h-8" src={APP.env.apps?.[os]?.image} /> Visita la tienda.
      </a>
    )
  }

  render() {
    const { mobile, os, version } = this.props

    if (!version || !os || !mobile || !APP.env.apps?.[os] || this.isUpToDate()) {
      return null
    }

    return (
      <div className="AppVersion p-4">
        <div className="rounded-lg border border-blueLight shadow-md flex flex-col gap-2 items-center justify-center p-2 bg-white">
          <span>
            <Emoji name="sweatbits" size="1em" /> Hay una <b>nueva versión</b> de la app.
          </span>
          {this.renderAppLink()}
        </div>
      </div>
    )
  }
}

AppVersion.propTypes = {
  mobile: PropTypes.bool,
  os: PropTypes.string,
  version: PropTypes.string,
}

export default AppVersion
